var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-info btn--bigger",
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.mostrarHistoricos }
              },
              [
                _c("i", { staticClass: "fa fa-history" }),
                _c("span", [_vm._v("Historial")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-success btn--bigger",
                on: { click: _vm.exportar }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Exportar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card mt-2" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "desde",
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.desde,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "desde", $$v)
                        },
                        expression: "form.desde"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Desde")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "hasta",
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.hasta,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "hasta", $$v)
                        },
                        expression: "form.hasta"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Hasta")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        placeholder: "Seleccione...",
                        options: _vm.recaudadores,
                        id: "recaudador",
                        name: "recaudador",
                        multiple: "",
                        label: "nombre"
                      },
                      on: {
                        input: _vm.inputRecaudador,
                        search: _vm.searchRecaudadores
                      },
                      model: {
                        value: _vm.selectedRecaudador,
                        callback: function($$v) {
                          _vm.selectedRecaudador = $$v
                        },
                        expression: "selectedRecaudador"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "recaudador" } }, [
                      _vm._v("Recaudador")
                    ])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-field select2 select2-field--stretch" },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          filterable: false,
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          options: _vm.bodegas,
                          id: "bodegas"
                        },
                        on: { input: _vm.inputBodega },
                        model: {
                          value: _vm.selectedBodega,
                          callback: function($$v) {
                            _vm.selectedBodega = $$v
                          },
                          expression: "selectedBodega"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "bodegas" } }, [
                        _vm._v("Sucursal")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        placeholder: "Seleccione...",
                        options: _vm.rutas,
                        id: "ruta",
                        name: "ruta",
                        label: "descripcion"
                      },
                      on: { input: _vm.inputRuta, search: _vm.searchRutas },
                      model: {
                        value: _vm.selectedRuta,
                        callback: function($$v) {
                          _vm.selectedRuta = $$v
                        },
                        expression: "selectedRuta"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "rutas" } }, [_vm._v("Ruta")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field select" }, [
                _c("div", { staticClass: "select-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipo_venta,
                          expression: "form.tipo_venta"
                        }
                      ],
                      attrs: { name: "tipo_venta", id: "tipo_venta" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "tipo_venta",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [_vm._v("Todos")]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "V" } }, [
                        _vm._v("Venta")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "R" } }, [
                        _vm._v("Recaudación")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "tipo_venta" } }, [
                    _vm._v("Tipo de venta")
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.dias.length > 0,
              expression: "dias.length > 0"
            }
          ],
          staticClass: "card mt-2"
        },
        [
          _c("div", { staticClass: "card__content" }, [
            _c(
              "div",
              {
                staticClass: "table-responsive",
                staticStyle: { "max-height": "300px" }
              },
              [
                _c("table", { staticClass: "custom-table" }, [
                  _c("thead", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          attrs: { colspan: "10" }
                        },
                        [
                          _vm._v(
                            "\n                  Valores de recaudación " +
                              _vm._s(_vm.periodo) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "tr",
                      [
                        _c("th", [_vm._v("Sucursal")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Ruta")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Tipo de venta")]),
                        _vm._v(" "),
                        _vm._l(_vm.dias, function(dia) {
                          return _c("th", { key: dia }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(dia) +
                                "\n                "
                            )
                          ])
                        }),
                        _vm._v(" "),
                        _c("th", [_vm._v("Total")])
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.consulta, function(item, index) {
                      return _c(
                        "tr",
                        {
                          key:
                            index + item.bodega_id + item.ruta + item.tipo_venta
                        },
                        [
                          _c("td", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(item.descripcion_bodega) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          !item.total
                            ? _c("td", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.ruta) +
                                    "\n                "
                                )
                              ])
                            : _c("td", [
                                _c("strong", [_vm._v(_vm._s(item.nombre))])
                              ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(item.tipo_venta) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.dias, function(dia) {
                            return _c("td", { key: dia }, [
                              !item.total
                                ? _c("span", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.moneyFormat(item[dia]) +
                                            " (" +
                                            item["total_ventas_" + dia] +
                                            ")"
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                                : _c("strong", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.moneyFormat(item[dia]) +
                                            " (" +
                                            item["total_ventas_" + dia] +
                                            ")"
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                            ])
                          }),
                          _vm._v(" "),
                          _c("td", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.totalPorRecaudador(item)))
                            ])
                          ])
                        ],
                        2
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("tfoot", [
                    _c(
                      "tr",
                      [
                        _c("th", { attrs: { scope: "row", colspan: "3" } }, [
                          _vm._v("\n                  Total\n                ")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.dias, function(dia) {
                          return _c("td", { key: dia + "total" }, [
                            _c("strong", [_vm._v(_vm._s(_vm.totalPorDia(dia)))])
                          ])
                        }),
                        _vm._v(" "),
                        _c("td", [
                          _c("strong", [_vm._v(_vm._s(_vm.totalFinal()))])
                        ])
                      ],
                      2
                    )
                  ])
                ])
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "historicos",
            height: "auto",
            width: "70%",
            scrollable: "",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [_c("reportes-historicos-excel", { attrs: { tipoReporte: "vr" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Reporte de valores recaudados")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Filtros de la consulta")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-778dedce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-778dedce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteValoresRecaudados.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-778dedce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteValoresRecaudados.vue
// module chunks = 0